"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import Image from "next/image";
export const TrailingTag = t0 => {
  const $ = _c(3);
  const {
    label,
    color
  } = t0;
  const text = label || "Trailing";
  const bgColor = color || "bg-EB5757";
  const t1 = `${bgColor} text-FFFFFF text-[11px] font-semibold px-3 py-1 rounded-md whitespace-nowrap`;
  let t2;
  if ($[0] !== t1 || $[1] !== text) {
    t2 = <div className="flex items-center justify-center"><span className={t1}>{text}</span></div>;
    $[0] = t1;
    $[1] = text;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};